import { findKeyParentInObj, findKeyInObj } from '../utils/objects';
import { noticeError } from 'app/api/analytics/reporting';
import merge from 'merge';

export function callApiByName(methodStr, context, params = [], brand) {
  // Bridge sometimes performs destructive actions on the object, so force a copy before giving to bridge
  const finalParams = params.map(p => merge.clone(p));

  if (brand) {
    finalParams[0] = {
      ...finalParams[0],
      brand,
    };
  }

  const apiFunc = findKeyInObj(context, methodStr);
  const apiContext = findKeyParentInObj(context, methodStr);
  if (apiFunc && apiContext) {
    let result = apiFunc.apply(apiContext, finalParams);
    if (!result || typeof result.then !== 'function') {
      noticeError(`Bridge API Method ${methodStr} did not return a promise`);
      return Promise.reject({ code: 'internal.noresponse' });
    }
    return result;
  }
  noticeError(`Bridge API method not found ${methodStr}`);
  return Promise.reject({ code: 'internal.methodnotfound' });
}



// WEBPACK FOOTER //
// ./src/app/api/bridge-proxy.js